import React, { useEffect } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { Table, Button, Row, Col } from 'react-bootstrap';
import Loader from '../components/Loader';
import Message from '../components/Message';
import {
	listProducts,
	deleteProduct,
	//createProduct,
} from '../actions/productActions';
import { PRODUCT_CREATE_RESET } from '../constants/productConstants';
import Paginate from '../components/Paginate';
import { refreshLogin, getUserDetails } from '../actions/userActions';
import getSymbolFromCurrency from 'currency-symbol-map'
import Meta from '../components/Meta'



const ProductListPage = ({ history, match }) => {
	const pageNumber = match.params.pageNumber || 1;
	const dispatch = useDispatch();
	const productList = useSelector((state) => state.productList);
	const { loading, products, error, pages, page } = productList;
	
	console.log(`Products from ProductList: ${products}`)
	
	const productDelete = useSelector((state) => state.productDelete);
	const {
		loading: loadingDelete,
		success: successDelete,
		error: errorDelete,
	} = productDelete;

	const productCreate = useSelector((state) => state.productCreate);
	const {
		loading: loadingCreate,
		success: successCreate,
		error: errorCreate,
		product: createdProduct,
	} = productCreate;

	const userLogin = useSelector((state) => state.userLogin);
	const { userInfo } = userLogin;

	const userDetails = useSelector((state) => state.userDetails);
	const { error: userLoginError } = userDetails;

	// fetch user login info
	useEffect(() => {
		userInfo
			&& dispatch(getUserDetails('profile'))
			//: dispatch(getUserDetails('profile'));
	}, [userInfo, dispatch]);
	// // fetch user login info
	// useEffect(() => {
	// 	userInfo
	// 		? userInfo.isSocialLogin
	// 			? dispatch(getUserDetails(userInfo.id))
	// 			: dispatch(getUserDetails('profile'))
	// 		: dispatch(getUserDetails('profile'));
	// }, [userInfo, dispatch]);

	// refresh token for expired access tokens
	useEffect(() => {
		if (userLoginError && userInfo) {
			const user = JSON.parse(localStorage.getItem('userInfo'));
			user && dispatch(refreshLogin(user.email));
		}
	}, [userLoginError, dispatch, userInfo]);

	useEffect(() => {
		if (!userInfo) history.push('/login');
		dispatch({ type: PRODUCT_CREATE_RESET }); //reset the new product detail
		if (successCreate)
			history.push(`/admin/product/${createdProduct._id}/edit`);
		else dispatch(listProducts('', pageNumber, 20)); // 3rd parameter is the no of products to be listed per page
	}, [
		dispatch,
		history,
		userInfo,
		successDelete,
		successCreate,
		createdProduct,
		pageNumber,
	]);

	// delete product after confirming
	const handleDelete = (id) => {
		if (window.confirm('Are you sure you wanna delete this product?'))
			dispatch(deleteProduct(id));
	};
	// create a new dummy product
	// const handleCreateProduct = () => {
	// 	dispatch(createProduct());
	// };
	return (
		<>
		<Meta title="My products"/>

			<Row className='align-items-center'>
				<Col>
					<h1 style={{
          					border: "0.5px solid #9ab49a",
          					marginBottom: "16px",
          					borderRadius: "16px",
          					paddingLeft: "12px",
		  					backgroundColor: '#e3ffe3',
		  					color: 'grey'
        				}}>Products</h1>
				</Col>
				<Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button
						className='my-3'
						style={{
							padding: '0.5em 1em',
							backgroundColor: 'green',
							border: 'none'
						}}
						onClick={() => {history.push('/products/new')}}>
						<i className='fas fa-plus' /> Create Product
					</Button>
				</Col>
			</Row>
			{errorDelete && (
				<Message dismissible variant='danger' duration={10}>
					{errorDelete}
				</Message>
			)}
			{errorCreate && (
				<Message dismissible variant='danger' duration={10}>
					{errorCreate}
				</Message>
			)}
			{loading || loadingCreate || loadingDelete ? (
				<Loader />
			) : error ? (
				<Message dismissible variant='danger' duration={10}>
					{error}
				</Message>
			) : (
				<>
					<Table
						striped
						bordered
						responsive
						className='table-sm text-center'>
						<thead>
							<tr>
								<th style={{backgroundColor: '#154a15', color: 'white', borderTopLeftRadius: '16px', borderRight: '1px solid white'}}>ID</th>
								<th style={{backgroundColor: '#154a15', color: 'white', borderRight: '1px solid white'}}>NAME</th>
								<th style={{backgroundColor: '#154a15', color: 'white', borderRight: '1px solid white'}}>PRICE</th>
								<th style={{backgroundColor: '#154a15', color: 'white', borderRight: '1px solid white'}}>CATEGORY</th>
								<th style={{backgroundColor: '#154a15', color: 'white', borderRight: '1px solid white'}}>BRAND</th>
								<th style={{backgroundColor: '#154a15', color: 'white', borderTopRightRadius: '16px', border: 'none'}}>ACTION</th>
							</tr>
						</thead>
						<tbody>
							{products &&
								products.map((product) => {
									return (
										<tr key={product._id}>
											<td>{product._id}</td>
											<td>{product.name}</td>
											<td>
												{getSymbolFromCurrency('NGN')} {product.price}
											</td>
											<td>{product.category}</td>
											<td>{product.brand}</td>

											<td
												style={{
													display: 'flex',
													alignItems: 'center',
													justifyContent:
														'space-around',
												}}>
												<LinkContainer
													to={`/products/${product._id}/edit`}>
													<Button
														variant='link'
														className='btn-sm'>
														<i className='fas fa-edit' />
													</Button>
												</LinkContainer>
												<Button
													className='btn-sm'
													onClick={() =>
														handleDelete(
															product._id
														)
													}
													variant='danger'>
													<i
														style={{
															fontSize: '0.9em',
															padding: '0',
														}}
														className='fas fa-trash'
													/>
												</Button>
											</td>
										</tr>
									);
								})}
						</tbody>
					</Table>
					<Paginate pages={pages} page={page} />
				</>
			)}
		</>
	);
};

export default ProductListPage;
